import React from 'react';
import Gradients from './Gradients';
import Footer from '../layouts/Footer';
import {Exp,ExploreContainer,Container} from '../../styles/Explore-Styles';

const Explore = () => {
    return(
        <>
        <Exp>
            <ExploreContainer>
            <Container>
                <Gradients/>
            </Container>
            </ExploreContainer>
        </Exp>
        <Footer/>
        </>
        )
}

export default Explore;